/**
 * Servicio compartido para importar y exportar Excel
 * Usado tanto en Facturas como en Recibos
 */

const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
  return localStorage.getItem("access_token");
}

/**
 * Descarga un archivo desde una URL autenticada
 * @param {string} url  - endpoint completo
 * @param {string} filename - nombre sugerido del archivo
 */
export async function downloadExcel(url, filename) {
  const res = await fetch(`${BASE_URL}${url}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  if (!res.ok) throw new Error("Error al descargar el archivo");

  const blob = await res.blob();
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

/**
 * Sube un archivo Excel al servidor
 * @param {string} url    - endpoint de importación
 * @param {File}   file   - archivo seleccionado por el usuario
 * @returns {Promise<{creadas?:number, creados?:number, errores:Array}>}
 */
export async function uploadExcel(url, file) {
  const formData = new FormData();
  formData.append("archivo", file);

  const res = await fetch(`${BASE_URL}${url}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Error al importar el archivo");
  }

  return res.json();
}
